var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-input",class:{
    big: _vm.size === 'big',
    medium: _vm.size === 'medium',
    small: _vm.size === 'small',
    'is-error': !!_vm.field.error
  }},[_c('the-mask',_vm._b({ref:_vm.field.name,class:[
      _vm.inputClass,
      {
        big: _vm.size === 'big',
        medium: _vm.size === 'medium',
        small: _vm.size === 'small',
        'no-label': !!_vm.$attrs['no-label']
      }
    ],attrs:{"mask":_vm.mask,"type":"text","name":_vm.field.name,"required":_vm.field.required,"placeholder":_vm.field.placeholder,"readonly":_vm.field.readonly,"disabled":_vm.disabled(_vm.field) || _vm.field.disabled,"masked":false,"autofocus":_vm.autofocus,"value":_vm.numberType
        ? _vm.localModel == 0 || _vm.localModel == ''
          ? (_vm.localModel = '')
          : (_vm.localModel = Number(_vm.localModel))
        : _vm.localModel},nativeOn:{"change":function($event){return _vm.handleChange.apply(null, arguments)},"blur":function($event){return _vm.handleChange.apply(null, arguments)},"input":function($event){return _vm.checkPhoneInput.apply(null, arguments)}},model:{value:(_vm.localModel),callback:function ($$v) {_vm.localModel=$$v},expression:"localModel"}},'the-mask',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }